
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46path_937tscjZcrwAMeta } from "/app/pages/[...path].vue?macro=true";
import { default as createKJgyKioIlfMeta } from "/app/pages/account/create.vue?macro=true";
import { default as _91_91pageId_93_93sYfMqV68MUMeta } from "/app/pages/apply/[[pageId]].vue?macro=true";
import { default as applywndI893Te2Meta } from "/app/pages/apply.vue?macro=true";
export default [
  {
    name: "path",
    path: "/:path(.*)*",
    component: () => import("/app/pages/[...path].vue")
  },
  {
    name: "account-create",
    path: "/account/create",
    component: () => import("/app/pages/account/create.vue")
  },
  {
    name: "apply",
    path: "/apply",
    component: () => import("/app/pages/apply.vue"),
    children: [
  {
    name: "apply-pageId",
    path: ":pageId?",
    component: () => import("/app/pages/apply/[[pageId]].vue")
  }
]
  }
]